// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-About-SystemBar----index-module---root---10H6u","title":"src-components-About-SystemBar----index-module---title---1J3kk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/SystemBar/index.module.css
// module id = 449
// module chunks = 213534597649335